import { render, staticRenderFns } from "./SjfsqDetail.vue?vue&type=template&id=53e9d4a6&scoped=true&"
import script from "./SjfsqDetail.vue?vue&type=script&lang=js&"
export * from "./SjfsqDetail.vue?vue&type=script&lang=js&"
import style0 from "../style.css?vue&type=style&index=0&id=53e9d4a6&prod&scoped=true&lang=css&"
import style1 from "./SjfsqDetail.vue?vue&type=style&index=1&id=53e9d4a6&prod&scoped=true&lang=css&"
import style2 from "./SjfsqDetail.vue?vue&type=style&index=2&id=53e9d4a6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e9d4a6",
  null
  
)

export default component.exports